module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/motherfatherson.28c563e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/motherfatherson.jpg
// module id = 2/J9
// module chunks = 0